<template>
  <div>
    <base-crud
      crudName="Pontos Manuais"
      newText="Novo Ponto Manual"
      :table="tableName"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
      :toadd="'/manualCheck'"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      tableName: "manualChecksTable",
      users: [],
      pages: [],
      url: "",
      columns: [
        "id",
        "user_id",
        "created_at_f",
        "created_by_name",
        "justification",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "created_at_f",
        "created_by_name",
        "justification",
      ],
      options: {
        filterByColumn: true,
        filterable: ["id", "user_id", "created_at_f", "created_by_name"],
        sortable: ["id", "user_id", "created_at_f", "created_by_name"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Usuário",
          created_at_f: "Data e Hora",
          created_by_name: "Registrado por",
          justification: "Justificativa",
          actions: "Ações",
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "createdByUser"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "-";
          },
          created_by_name: function (h, row, index) {
            return row.created_by_user ? row.created_by_user.name : "-";
          },
        },
      },
      endPoint: "checks/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        created_at_f: "created_at_f",
        created_by_name: "createdByUser[name]",
      };
      let filters = "manual=1&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
